import { lazy } from 'react';
import Permission from './pages/Permission';
import HomeRedirect from './pages/HomeRedirect';
import SignaturePad from './components/signature/SignaturePad';
import PkgpStepsForm from './components/pkgp/PkgpStepsForm';
import PugiStepsForm from './components/pugi/PugiStepsForm';

const Users = lazy(() => import('./components/users/Users'));
const UsersForm = lazy(() => import('./components/users/UsersForm'));
const UsersNew = lazy(() => import('./components/users/UsersNew'));

// import Artikal from './components/artikal/Artikal';
// import ArtikalForm from './components/artikal/ArtikalForm';

// magacin dashboard

const Artikal = lazy(() => import('./components/artikal/Artikal'));
const ArtikalForm = lazy(() => import('./components/artikal/ArtikalForm'));

const MarkaTrosila = lazy(() => import('./components/markatrosila/MarkaTrosila'));
const MarkaTrosilaForm = lazy(() => import('./components/markatrosila/MarkaTrosilaForm'));

const Cenovnik = lazy(() => import('./components/cenovnik/Cenovnik'));
const CenovnikForm = lazy(() => import('./components/cenovnik/CenovnikForm'));

const Dokumenti = lazy(() => import('./components/dokumenti/Dokumenti'));
const DokumentiForm = lazy(() => import('./components/dokumenti/DokumentiForm'));

const Faktura = lazy(() => import('./components/faktura/Faktura'));
const FakturaForm = lazy(() => import('./components/faktura/FakturaForm'));

const Groups = lazy(() => import('./components/groups/Groups'));
const GroupsForm = lazy(() => import('./components/groups/GroupsForm'));

const Jm = lazy(() => import('./components/jm/Jm'));
const JmForm = lazy(() => import('./components/jm/JmForm'));

const Kurs = lazy(() => import('./components/kurs/Kurs'));
const KursForm = lazy(() => import('./components/kurs/KursForm'));

const M = lazy(() => import('./components/m/M'));
const MForm = lazy(() => import('./components/m/MForm'));

const MmForm = lazy(() => import('./components/mm/MmForm'));
const MmNewNalog = lazy(() => import('./components/mm/MmNewNalog'));
const MmSimple = lazy(() => import('./components/mm/MmSimple'));
const MmAdmin = lazy(() => import('./components/mm/MmAdmin'));
const MmUpload = lazy(() => import('./components/mm/MmUpload'));
const Mm = lazy(() => import('./components/mm/Mm'));

// const MmImport = lazy(() => import('./components/mmimport/MmImport'));
// const MmImportForm = lazy(() => import('./components/mmimport/MmImportForm'));

// const ModelHasRoles = lazy(() => import('./components/modelhasroles/ModelHasRoles'));
// const ModelHasRolesForm = lazy(() => import('./components/modelhasroles/ModelHasRolesForm'));

const Mrs = lazy(() => import('./components/mrs/Mrs'));
const MrsForm = lazy(() => import('./components/mrs/MrsForm'));

const NamenaPotrosnje = lazy(() => import('./components/namenapotrosnje/NamenaPotrosnje'));
const NamenaPotrosnjeForm = lazy(() => import('./components/namenapotrosnje/NamenaPotrosnjeForm'));

const Ni = lazy(() => import('./components/ni/Ni'));
const NiForm = lazy(() => import('./components/ni/NiForm'));

const P = lazy(() => import('./components/p/P'));
const PForm = lazy(() => import('./components/p/PForm'));

const Param = lazy(() => import('./components/param/Param'));
const ParamForm = lazy(() => import('./components/param/ParamForm'));

// const Permissions = lazy(() => import('./components/permissions/Permissions'));
// const PermissionsForm = lazy(() => import('./components/permissions/PermissionsForm'));

const Pkgp = lazy(() => import('./components/pkgp/Pkgp'));
const PkgpForm = lazy(() => import('./components/pkgp/PkgpForm'));

const Pp = lazy(() => import('./components/pp/Pp'));
const PpForm = lazy(() => import('./components/pp/PpForm'));

const Pugi = lazy(() => import('./components/pugi/Pugi'));
const PugiForm = lazy(() => import('./components/pugi/PugiForm'));

// const Roles = lazy(() => import('./components/roles/Roles'));
// const RolesForm = lazy(() => import('./components/roles/RolesForm'));

const Rvp = lazy(() => import('./components/rvp/Rvp'));
const RvpForm = lazy(() => import('./components/rvp/RvpForm'));

const Si = lazy(() => import('./components/si/Si'));
const SiForm = lazy(() => import('./components/si/SiForm'));

const Status = lazy(() => import('./components/status/Status'));
const StatusForm = lazy(() => import('./components/status/StatusForm'));

// const StavkaFakture = lazy(() => import('./components/stavkafakture/StavkaFakture'));
// const StavkaFaktureForm = lazy(() => import('./components/stavkafakture/StavkaFaktureForm'));

const TipTrosila = lazy(() => import('./components/tiptrosila/TipTrosila'));
const TipTrosilaForm = lazy(() => import('./components/tiptrosila/TipTrosilaForm'));

const UsersGroups = lazy(() => import('./components/usersgroups/UsersGroups'));
const UsersGroupsForm = lazy(() => import('./components/usersgroups/UsersGroupsForm'));

// const UsersRole = lazy(() => import('./components/usersrole/UsersRole'));
// const UsersRoleForm = lazy(() => import('./components/usersrole/UsersRoleForm'));

const Valuta = lazy(() => import('./components/valuta/Valuta'));
const ValutaForm = lazy(() => import('./components/valuta/ValutaForm'));

const ViParam = lazy(() => import('./components/viparam/ViParam'));
const ViParamForm = lazy(() => import('./components/viparam/ViParamForm'));

const Vno = lazy(() => import('./components/vno/Vno'));
const VnoForm = lazy(() => import('./components/vno/VnoForm'));

const Vparam = lazy(() => import('./components/vparam/Vparam'));
const VparamForm = lazy(() => import('./components/vparam/VparamForm'));

const Zm = lazy(() => import('./components/zm/Zm'));
const ZmStepsForm = lazy(() => import('./components/zm/ZmStepsForm'));

const MyProfile = lazy(() => import('./pages/MyProfile'));
const MySignature = lazy(() => import('./pages/MySignature'));

const LaravelPermission = lazy(() => import('./components/laravel-permission/LaravelPermission'));
const ModelHasRolesForm = lazy(() => import('./components/laravel-permission/ModelHasRoles/ModelHasRolesForm'));

const LocationCapture = lazy(() => import('./components/geolocator/LocationCapture'));

const routes = [
    { path: '/', element: <HomeRedirect /> },
    { path: '/artikal', element: <Artikal /> },
    { path: '/artikal/new', element: <ArtikalForm /> },
    { path: '/artikal/:id/edit', element: <ArtikalForm /> },
    { path: '/permission', element: <Permission /> },
    { path: '/signature', element: <SignaturePad /> },
    { path: '/users', element: <Users /> },
    { path: '/users/new', element: <UsersNew /> },
    { path: '/users/:id/edit', element: <UsersForm /> },

    { path: '/my-profile', element: <MyProfile /> },
    { path: '/my-signature', element: <MySignature /> },

    { path: '/cenovnik', element: <Cenovnik /> },
    { path: '/cenovnik/new', element: <CenovnikForm /> },
    { path: '/cenovnik/:id/edit', element: <CenovnikForm /> },

    { path: '/dokumenti', element: <Dokumenti /> },
    { path: '/dokumenti/new', element: <DokumentiForm /> },
    { path: '/dokumenti/:id/edit', element: <DokumentiForm /> },

    { path: '/faktura', element: <Faktura /> },
    { path: '/faktura/new', element: <FakturaForm /> },
    { path: '/faktura/:id/edit', element: <FakturaForm /> },

    { path: '/groups', element: <Groups /> },
    { path: '/groups/new', element: <GroupsForm /> },
    { path: '/groups/:id/edit', element: <GroupsForm /> },

    { path: '/jm', element: <Jm /> },
    { path: '/jm/new', element: <JmForm /> },
    { path: '/jm/:id/edit', element: <JmForm /> },

    { path: '/kurs', element: <Kurs /> },
    { path: '/kurs/new', element: <KursForm /> },
    { path: '/kurs/:id/edit', element: <KursForm /> },

    { path: '/m', element: <M /> },
    { path: '/m/new', element: <MForm /> },
    { path: '/m/:id/edit', element: <MForm /> },

    { path: '/markatrosila', element: <MarkaTrosila /> },
    { path: '/markatrosila/new', element: <MarkaTrosilaForm /> },
    { path: '/markatrosila/:id/edit', element: <MarkaTrosilaForm /> },

    { path: '/mm', element: <Mm /> },
    { path: '/mm-simple', element: <MmSimple /> },
    { path: '/mm/new', element: <MmForm /> },
    { path: '/mm/:id/edit', element: <MmForm /> },
    { path: '/mm/newnalog', element: <MmNewNalog /> },
    { path: '/mm/:barcode/barcode', element: <MmNewNalog /> },
    { path: '/mmadmin', element: <MmAdmin /> },
    { path: '/mmupload', element: <MmUpload /> },

    // { path: '/mmimport', element: <MmImport /> },
    // { path: '/mmimport/new', element: <MmImportForm /> },
    // { path: '/mmimport/:id/edit', element: <MmImportForm /> },

    // { path: '/modelhasroles', element: <ModelHasRoles /> },
    // { path: '/modelhasroles/new', element: <ModelHasRolesForm /> },
    // { path: '/modelhasroles/:id/edit', element: <ModelHasRolesForm /> },

    { path: '/mrs', element: <Mrs /> },
    { path: '/mrs/new', element: <MrsForm /> },
    { path: '/mrs/:id/edit', element: <MrsForm /> },

    { path: '/namenapotrosnje', element: <NamenaPotrosnje /> },
    { path: '/namenapotrosnje/new', element: <NamenaPotrosnjeForm /> },
    { path: '/namenapotrosnje/:id/edit', element: <NamenaPotrosnjeForm /> },

    { path: '/ni', element: <Ni /> },
    { path: '/ni/new', element: <NiForm /> },
    { path: '/ni/:id/edit', element: <NiForm /> },

    { path: '/p', element: <P /> },
    { path: '/p/new', element: <PForm /> },
    { path: '/p/:id/edit', element: <PForm /> },

    { path: '/param', element: <Param /> },
    { path: '/param/new', element: <ParamForm /> },
    { path: '/param/:id/edit', element: <ParamForm /> },

    // { path: '/permissions', element: <Permissions /> },
    // { path: '/permissions/new', element: <PermissionsForm /> },
    // { path: '/permissions/:id/edit', element: <PermissionsForm /> },

    { path: '/pkgp', element: <Pkgp /> },
    { path: '/pkgp/new', element: <PkgpForm /> },
    { path: '/pkgp/:id/edit', element: <PkgpStepsForm /> },
    //{ path: '/pkgp/:id/edit', element: <PkgpForm /> },
    // { path: '/pkgp/:id/steps', element: <PkgpStepsForm /> },

    { path: '/pp', element: <Pp /> },
    { path: '/pp/new', element: <PpForm /> },
    { path: '/pp/:id/edit', element: <PpForm /> },

    { path: '/pugi', element: <Pugi /> },
    { path: '/pugi/new', element: <PugiForm /> },
    { path: '/pugi/:id/edit', element: <PugiStepsForm /> },

    // { path: '/roles', element: <Roles /> },
    // { path: '/roles/new', element: <RolesForm /> },
    // { path: '/roles/:id/edit', element: <RolesForm /> },

    { path: '/rvp', element: <Rvp /> },
    { path: '/rvp/new', element: <RvpForm /> },
    { path: '/rvp/:id/edit', element: <RvpForm /> },

    { path: '/si', element: <Si /> },
    { path: '/si/new', element: <SiForm /> },
    { path: '/si/:id/edit', element: <SiForm /> },

    { path: '/status', element: <Status /> },
    { path: '/status/new', element: <StatusForm /> },
    { path: '/status/:id/edit', element: <StatusForm /> },

    // { path: '/stavkafakture', element: <StavkaFakture /> },
    // { path: '/stavkafakture/new', element: <StavkaFaktureForm /> },
    // { path: '/stavkafakture/:id/edit', element: <StavkaFaktureForm /> },

    { path: '/tiptrosila', element: <TipTrosila /> },
    { path: '/tiptrosila/new', element: <TipTrosilaForm /> },
    { path: '/tiptrosila/:id/edit', element: <TipTrosilaForm /> },

    { path: '/users', element: <Users /> },
    { path: '/users/new', element: <UsersNew /> },
    { path: '/users/:id/edit', element: <UsersForm /> },

    { path: '/usersgroups', element: <UsersGroups /> },
    { path: '/usersgroups/new', element: <UsersGroupsForm /> },
    { path: '/usersgroups/:id/edit', element: <UsersGroupsForm /> },

    // { path: '/usersrole', element: <UsersRole /> },
    // { path: '/usersrole/new', element: <UsersRoleForm /> },
    // { path: '/usersrole/:id/edit', element: <UsersRoleForm /> },

    { path: '/valuta', element: <Valuta /> },
    { path: '/valuta/new', element: <ValutaForm /> },
    { path: '/valuta/:id/edit', element: <ValutaForm /> },

    { path: '/viparam', element: <ViParam /> },
    { path: '/viparam/new', element: <ViParamForm /> },
    { path: '/viparam/:id/edit', element: <ViParamForm /> },

    { path: '/vno', element: <Vno /> },
    { path: '/vno/new', element: <VnoForm /> },
    { path: '/vno/:id/edit', element: <VnoForm /> },

    { path: '/vparam', element: <Vparam /> },
    { path: '/vparam/new', element: <VparamForm /> },
    { path: '/vparam/:id/edit', element: <VparamForm /> },

    { path: '/zm', element: <Zm /> },
    { path: '/zm/new', element: <ZmStepsForm /> },
    { path: '/zm/:id/edit', element: <ZmStepsForm /> },

    { path: '/permissions', element: <LaravelPermission /> },
    { path: '/permissions/model-has-roles/new', element: <ModelHasRolesForm /> },
    { path: '/permissions/model-has-roles/:roleId/:userId/edit', element: <ModelHasRolesForm /> },

    { path: '/location-capture', element: <LocationCapture /> }
];

export default routes;
